import { render, staticRenderFns } from "./PricePanelItem.vue?vue&type=template&id=946f17b2&scoped=true&"
import script from "./PricePanelItem.vue?vue&type=script&lang=js&"
export * from "./PricePanelItem.vue?vue&type=script&lang=js&"
import style0 from "./PricePanelItem.vue?vue&type=style&index=0&id=946f17b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946f17b2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('946f17b2')) {
      api.createRecord('946f17b2', component.options)
    } else {
      api.reload('946f17b2', component.options)
    }
    module.hot.accept("./PricePanelItem.vue?vue&type=template&id=946f17b2&scoped=true&", function () {
      api.rerender('946f17b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pricing/PricePanelItem.vue"
export default component.exports